document.querySelector('.search__form').addEventListener('submit', function () {
    var btn     = this.querySelector('[type="submit"]');
    var label   = btn.querySelector('.btn-label');
    var spinner = btn.querySelector('.btn-spinner');
    if (!label || !spinner) return;
    label.style.display   = 'none';
    spinner.style.display = 'inline-block';
});
